import React, { useState } from 'react';
import Footer from '../../../components/Footer';
import VegIcon from '../../../components/VegIcon';
import OffersRenderer from '../../../components/OffersRenderer';
import './CosmicCantina.css';

import DEFAULT_LOGO from '../../../assets/defaults/logo-default.jpg';
import DEFAULT_ITEM from '../../../assets/defaults/item-default.jpg';

const CosmicCantina = ({ data }) => {
    const restaurant = data?.restaurant || {};
    const menus = data?.menus || [];

    const [stage, setStage] = useState('galaxy'); // galaxy (menus) -> solar (categories) -> planet (items)
    const [activeMenu, setActiveMenu] = useState(null);
    const [activeCategory, setActiveCategory] = useState(null);
    const [selectedItem, setSelectedItem] = useState(null);

    const selectMenu = (menu) => {
        setActiveMenu(menu);
        setStage('solar');
        window.scrollTo(0, 0);
    };

    const selectCategory = (cat) => {
        setActiveCategory(cat);
        setStage('planet');
        window.scrollTo(0, 0);
    };

    if (!data) return <div className="cosmic-loading">Initiating Warp Drive...</div>;

    return (
        <div className="cosmic-root">
            <div className="stars"></div>
            <div className="twinkling"></div>

            <header className="cosmic-header">
                <div className="cosmic-ufo">
                    <img src={restaurant.logoUrl || DEFAULT_LOGO} alt="logo" className="cosmic-logo" />
                </div>
                <h1 className="cosmic-title">{restaurant.name}</h1>
                <p className="cosmic-coords">{restaurant.address || 'Quadrant 7, Orion Belt'}</p>
            </header>

            {/* Offers / Notes */}
            <OffersRenderer offers={data?.offers} />

            <main className="cosmic-main">
                {stage === 'galaxy' && (
                    <div className="cosmic-galaxy-view">
                        <h2 className="cosmic-view-label">Select Your Galaxy (Menu)</h2>
                        <div className="cosmic-galaxy-grid">
                            {menus.map((menu, idx) => (
                                <div key={menu.id} className={`cosmic-menu-orb orb-${idx % 4}`} onClick={() => selectMenu(menu)}>
                                    <div className="orb-content">
                                        <h3>{menu.name}</h3>
                                        <span>{menu.categories?.length} Systems</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {stage === 'solar' && activeMenu && (
                    <div className="cosmic-solar-view">
                        <button className="cosmic-nav-back" onClick={() => setStage('galaxy')}>← Return to Galaxy</button>
                        <h2 className="cosmic-view-label">{activeMenu.name} Systems</h2>
                        <div className="cosmic-solar-list">
                            {activeMenu.categories?.map((cat, idx) => (
                                <div key={cat.id} className="cosmic-cat-row" onClick={() => selectCategory(cat)}>
                                    <div className="cat-scanner"></div>
                                    <div className="cat-info">
                                        <h3>{cat.name}</h3>
                                        <p>{cat.description || 'Interstellar delicacies awaits'}</p>
                                    </div>
                                    <div className="cat-count">{(cat.items || []).length} Planets</div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {stage === 'planet' && activeCategory && (
                    <div className="cosmic-planet-view">
                        <button className="cosmic-nav-back" onClick={() => setStage('solar')}>← Back to Solar System</button>
                        <h2 className="cosmic-view-label">{activeCategory.name} Exploration</h2>
                        <div className="cosmic-item-grid">
                            {activeCategory.items?.map(item => (
                                <div key={item.id} className="cosmic-item-card" onClick={() => setSelectedItem(item)}>
                                    <div className="item-portal">
                                        <img src={item.imageUrl || DEFAULT_ITEM} alt={item.name} />
                                        <div className="item-price-tag">₹{item.price}</div>
                                    </div>
                                    <div className="item-details">
                                        <div className="cosmic-item-title">
                                            {(item.isVeg !== undefined && item.isVeg !== null) && (
                                                <span className={`cosmic-veg-badge ${item.isVeg ? 'veg' : 'nonveg'}`}>
                                                    <span className="cosmic-veg-dot"></span>
                                                </span>
                                            )}
                                            <h3>{item.name}</h3>
                                        </div>
                                        <p className="cosmic-trunc-2">{item.description}</p>
                                        <div className="item-meta">
                                            {item.tags?.slice(0, 2).map(t => <span key={t} className="meta-badge">#{t}</span>)}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </main>

            {selectedItem && (
                <div className="cosmic-nebula-modal" onClick={() => setSelectedItem(null)}>
                    <div className="nebula-content" onClick={e => e.stopPropagation()}>
                        <button className="nebula-close" onClick={() => setSelectedItem(null)}>×</button>
                        <div className="nebula-img">
                            <img src={selectedItem.imageUrl || DEFAULT_ITEM} alt={selectedItem.name} />
                        </div>
                        <div className="nebula-body">
                            <h2>{selectedItem.name}</h2>
                            <p>{selectedItem.description}</p>
                            <div className="nebula-options">
                                <h3>Module Configurations (Variants)</h3>
                                {selectedItem.variants?.filter(v => v.isActive).map(v => (
                                    <div key={v.id} className="nebula-row">
                                        <span>{v.name}</span>
                                        <span className="row-divider"></span>
                                        <span>{v.price > 0 ? `₹${v.price}` : 'Included'}</span>
                                    </div>
                                ))}
                                {(!selectedItem.variants || selectedItem.variants.length === 0) && (
                                    <div className="nebula-empty">Standard issue configuration.</div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <Footer />
        </div>
    );
};

export default CosmicCantina;
